import React, {createContext, useContext} from "react";

export type ClientConfigType = {
    apiUrl: string,
    websiteUrl: string,
    applicationInsightsConnectionString: string,
    avatarServiceApiUrl: string
}

export const ClientConfig = createContext<ClientConfigType>({
    apiUrl: null!,
    websiteUrl: null!,
    applicationInsightsConnectionString: null!,
    avatarServiceApiUrl: null!
});

export function ClientConfigProvider({children, config}: { children: React.ReactNode, config: ClientConfigType }) {
    return <ClientConfig.Provider value={config}>
        {children}
    </ClientConfig.Provider>;
}

export function useConfig() {
    return useContext(ClientConfig);
}
